<template>
  <div class="bg-card wow fadeInDown">
    <div class="zy-container">
      <div class="card">
        <div class="card-col">
          <div class="card-head">
            <div class="card-title">
              多维数据统计，量化直播效果
            </div>
            <div class="card-func-desc">
              直播数据指导实时互动；卖货数据优化选品方
            </div>
            <div class="flex">
              <div class="open-btn" @click="openHandler">开启你专属的直播间</div>
            </div>
            <el-image :src="require('@/assets/images/index/live-video/img4.png')" class="img-icon"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from "wowjs";
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  components: {},
  data() {
    return {}
  },
  methods: {
    openHandler() {
      this.$router.push("/login");
    }
  }
}
</script>

<style scoped lang="scss">
.bg-card {
  background: #F8F8FC;
  padding-bottom: 2px;
}

.func-title {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  padding-bottom: 100px;
}

.card {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .card-col {
    padding-top: 43px;
    padding-bottom: 43px;
    width: 100%;
    margin-bottom: 2%;
    background: #FFFFFF;
    border-radius: 30px;
    transition: transform 0.3s ease-in-out;
  }

  .card-col:hover {
    transform: scale3d(1.01, 1.01, 1.01);
    box-shadow: 0px 0 52px 0px rgba(225, 225, 246, 0.45);
  }

}


.card-head {
  width: 88%;
  margin: 0 auto;

  .card-title {
    font-size: 29px;
    font-weight: 600;
    color: #333333;
    text-align: center;
    position: relative;
    padding-bottom: 16px;
  }

  .card-title:after {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    background: linear-gradient(137deg, #E266FF 0%, #00FCFF 100%);
    border-radius: 4px;
  }

  .card-func-desc {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 27px;
    line-height: 33px;
  }

}

.flex {
  display: flex;
  justify-content: center;
}

.open-btn {
  font-size: 16px;
  background-image: linear-gradient(180deg, #404DFF 0%, #918BFF 100%) !important;
  border: none;
  height: 40px;
  padding-left: 30px;
  padding-right: 30px;
  text-align: center;
  line-height: 40px;
  color: #FFFFFF;
  outline: none;
  border-radius: 10px;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
}

.img-icon {
  width: 790px;
  display: block;
  margin: 0 auto;
}


</style>
